<template>
  <div :class="{ 'd-none': hidden }">
    <AppTooltip
      placement="top"
      :disabled="!config.value"
    >
      <FormInputButton
        :disabled="disabled"
        :required="required"
        :invalid="invalid && dirty"
        :error="error"
        :label="label"
        @click="openLinkInNewTab()"
      >
        <input
          v-if="config.value"
          class="text-primary text-truncate w-100 border-0 cursor-pointer"
          :value="dynamicRender"
        />
        <div
          v-else
          class="text-muted"
        >-</div>
      </FormInputButton>
      <template #tooltip>
        <strong>Open Link</strong>
        <div>{{ dynamicRender }}</div>
      </template>
    </AppTooltip>
  </div>
</template>

<script>
import FormInputButton from './FormInputButton'
import FormMixin from './FormMixin'
import dynamicString from '@shared/utils/dynamicString'
import { inject } from '@vue/composition-api'

export default {
  mixins: [ FormMixin ],
  components: { FormInputButton },
  props: {
    formValue: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props) {
    const course = inject('course', {})
    const term = inject('term', {})

    const dynamicFieldValuePath = inject('dynamic_field_value_path', [])
    const contextPath = dynamicFieldValuePath.slice(0, -1)

    return { course, term, contextPath }
  },
  computed: {
    dynamicPropertiesToOverwrite () {
      return {
        termCode: this.term.termCode,
        subjectCode: this.course?.subjectCode,
        courseNumber: this.course?.courseNumber,
        career: this.course?.career,
      }
    },
    dynamicRender () {
      return dynamicString.getDynamicRender(this.config.value, {
        ...this.formValue,
        ...this.dynamicPropertiesToOverwrite,
      }, {
        contextPath: this.contextPath,
      })
    },
  },
  methods: {
    openLinkInNewTab () {
      if (!this.config.value) return
      window.open(this.dynamicRender, '_blank')
    },
  },
}
</script>
